import { render, staticRenderFns } from "./directUpdate.vue?vue&type=template&id=010ce96d&"
import script from "./directUpdate.vue?vue&type=script&lang=js&"
export * from "./directUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports